export const isTreatmentItemPaid = (item: any) => {
  if (!item) return false;
  if (item.paymentId) return true;
  const paid = item.paid;
  if (paid === true || paid === 1) return true;
  if (typeof paid === "string" && paid.trim().toLowerCase() === "true") {
    return true;
  }
  return false;
};

/** Sub-treatment stages priced individually (as opposed to "included"/free stages). */
export const isPricedSubTreatment = (subItem: any) =>
  subItem?.selected_option === "treatment_paid" ||
  subItem?.selected_option === "treatment_stage";

/**
 * Long-term treatment plans never bill their parent line directly — they bill
 * one stage (sub-treatment) at a time. "Treatment cost" for a plan is the sum of the
 * priced stages that have moved past planning (ongoing/Complete).
 */
export const getSubTreatmentPaidAmount = (subTreatments: any[]) =>
  (subTreatments ?? []).reduce((sum, sub) => {
    if (
      !isPricedSubTreatment(sub) ||
      sub?.status === "long term" ||
      sub?.status === "planned"
    ) {
      return sum;
    }
    const price = parseFloat(sub?.price);
    return sum + (Number.isFinite(price) ? price : 0);
  }, 0);

/**
 * Amount already paid via invoice/payment for case (sub) treatments.
 * Uses priced stages that have been marked paid / linked to a payment.
 */
export const getSubTreatmentPaymentReceivedAmount = (subTreatments: any[]) =>
  (subTreatments ?? []).reduce((sum, sub) => {
    if (!isPricedSubTreatment(sub) || !isTreatmentItemPaid(sub)) {
      return sum;
    }
    const price = parseFloat(sub?.price);
    return sum + (Number.isFinite(price) ? price : 0);
  }, 0);

/** Amount of treatment cost still unpaid (never negative). */
export const getTreatmentDueAmount = (
  treatmentCost: number,
  paymentReceived: number
) => Math.max(0, (Number(treatmentCost) || 0) - (Number(paymentReceived) || 0));

/** Balance still owed on a long-term treatment plan (never negative). */
export const getLongTermBalancePayable = (
  estimate: number,
  paidAmount: number
) => Math.max(0, (Number(estimate) || 0) - (Number(paidAmount) || 0));

/** Unpaid items are always editable. Paid items only when Super Admin allows it. */
export const isTreatmentItemEditable = (
  item: any,
  allowPaidForSuperAdmin = false
) =>
  Boolean(item?._id) &&
  (!isTreatmentItemPaid(item) || allowPaidForSuperAdmin);

/** Delete stays blocked for paid items for everyone. */
export const isTreatmentItemDeletable = (item: any) =>
  Boolean(item?._id) && !isTreatmentItemPaid(item);
